<template>
  <button type="button" class="my-button">
    <span><slot></slot></span>
  </button>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.my-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  color: #525250;
  -webkit-appearance: none;
  text-align: left;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 10px 20px;
  font-size: 15px;
  border-radius: 8px;
  width: 188px;
  height: 40px;
  cursor: inherit;
  background-color: #F2F2ED;
  border: 0;
}

</style>
